module.exports = __webpack_public_path__ + "img/ep7-7b.9c6f8c19.png";